/** @format */
import { _$ } from '@king-design/react'

import { specialAttrs } from 'src/components/GraphX6/container'
import { Cell } from '@antv/x6'
import _ from 'lodash'
import { ConcatProps } from 'src/components/AlarmReciver/new'
import { ProcessRecordVariableProps } from '../Record/container'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import { getScene } from 'src/api/ApiEventOpsScene'
import { getScript, saveScript } from 'src/api/ApiEventOpsScript'

// 节点类型枚举
export const NodeTypeEnum = {
  START: _$('开始'), // 开始
  AUTOTASK_DISPLAY: _$('数据处理'), // 数据处理
  GATEWAY: _$('验证'), // 验证
  PARALLEL_GATEWAY: _$('会签'), // 会签
  AUTOTASK_SUBSCENE: _$('子场景'), // 子场景
  AUTOTASK_TIMER: _$('定时器'), // 定时器
  USERTASK: _$('人工介入'), // 人工介入
  END: _$('结束') // 结束
}

// 输入参数类型
export const InputTypeEnum = {
  global: _$('流程输入'),
  fixed: _$('固定值'),
  node_input: _$('前置节点输入'),
  node_output: _$('前置节点输出')
}

// 节点描述信息
export const geNodetDescription = (type: keyof typeof NodeTypeEnum) => {
  switch (type) {
    // 验证
    case 'GATEWAY':
      return _$('验证节点的输入参数，可作为路由选择的判定。')
    // 结束
    case 'END':
      return _$('流程输出将作为流程流转完毕的结果，常用于结果的通知内容和作为子节点时的节点输出。')
    // 人工介入
    case 'USERTASK':
      return _$('输入参数收集到的值，可以在功能按钮中进行查看和编辑处理。')
    default:
      return _$('输入参数收集到的值，可以在数据脚本中以普通变量的方式使用。')
  }
}

// 根据场景ID获取输入输出参数
export const getFlowParamsInfo = (scentPrams, type: 'input' | 'output') => {
  const {
    Workflow: { Nodes }
  } = scentPrams
  if (!Array.isArray(Nodes)) return []
  if (type === 'output') {
    return _.uniq(
      (Nodes.filter(itemNode => itemNode.Type === 'END') || []).reduce((acc, cur) => {
        if (cur.Extra?.Outputs) {
          acc.push(...cur.Extra.Outputs)
        }
        return acc
      }, [])
    )
  } else if (type === 'input') {
    return _.uniq(
      Nodes.reduce((acc, cur) => {
        if (cur.Extra?.Inputs) {
          acc.push(...cur.Extra.Inputs.filter(item => item.Type === 'global').map(item => item.Key))
        }
        return acc
      }, [])
    )
  }
}

export interface SceneRecordItemProp {
  ID: number
  Creator: string
  FormSchema: string
  IsPublic: number
  Name: string
  PublishAt: string
  Remark: string
  Sign: string
  Status: number
  TriggerCount: number
  Version: string
}

// 节点输入参数
export interface ProcessRecordNodeInputProps {
  Type: keyof typeof InputTypeEnum
  Key: string
  SourceNodeSign?: string
  SourceNode?: string
  Value?: string
  SourceKey?: string
  Secret?: boolean
}
// 节点属性
export interface ProcessRecordNodeProps {
  ID?: number
  ProcesDetails?: ProcessRecordNodeProps //流程中节点性情
  ProcessID?: number
  Name: string
  Sign: string
  Type: string
  Extra: {
    Inputs?: ProcessRecordNodeInputProps[]
    Outputs?: {
      Type: string
      Key: string
    }[]
    ScriptID?: number
    SubSceneSign?: string
    Delay?: number
    Other?: {
      Ports: {
        Items: {
          Group: string
          ID: string
        }[]
      }
      Position: {
        X: number
        Y: number
      }
      Shape: string
      Size: {
        Height: number
        Width: number
      }
    }
    UrlNotices?: string[]
    UserNotices?: ConcatProps[]
  }
  IsActive?: number
  CreatedAt?: string
  FinishedAt?: string
}
// 边属性
export interface ProcessRecordRouteProps {
  ID?: number
  ProcessID?: number
  Name: string
  Sign: string
  DstNodeSign?: string
  SrcNodeSign?: string
  Extra: {
    Other?: {
      ID: string
      Shape: string
      Source: {
        Cell: string
        Port: string
      }
      Target: {
        Cell: string
        Port: string
      }
    }
  }
  IsActive?: number
  Conditions?: string[]
}

export interface SceneRecordDetailProps extends SceneRecordItemProp {
  Approving: boolean
  ApprovingID: number
  AccountID: string
  WfModelID: number
  CurrentVersion: string
  PublishedAt: string | null
  VersionRemark: string
  WfStorage: string | null
  CreatedAt?: string
  UpdatedAt?: string
  Workflow: {
    Nodes: ProcessRecordNodeProps[]
    Routes: ProcessRecordRouteProps[]
  }
}

// 节点端口
export const commonPorts = {
  groups: {
    top: {
      position: 'top',
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'hidden'
          }
        }
      }
    },
    right: {
      position: 'right',
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'hidden'
          }
        }
      }
    },
    bottom: {
      position: 'bottom',
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'hidden'
          }
        }
      }
    },
    left: {
      position: 'left',
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'hidden'
          }
        }
      }
    }
  },
  items: [
    {
      group: 'top'
    },
    {
      group: 'right'
    },
    {
      group: 'bottom'
    },
    {
      group: 'left'
    }
  ]
}

// 设置各个类型节点的data
export const handleNodeData = (nodes: ProcessRecordNodeProps[]) => {
  if (!Array.isArray(nodes)) return []
  const result = nodes.map(node => {
    const { ProcessID, Type, Name, Sign, Extra, IsActive, CreatedAt, FinishedAt, ProcesDetails } =
      node
    const { Inputs, Outputs, ScriptID, SubSceneSign, Delay, Other, UrlNotices, UserNotices } =
      Extra || {}
    const { Shape, Size, Position, Ports } = Other || {}
    const attrs = cloneDeep(specialAttrs.nodes[Type])
    if (IsActive === 2) {
      attrs.body.style = {
        stroke: '#a1d682',
        fill: '#a1d682'
      }
    } else if (IsActive === 1) {
      attrs.body.style = {
        stroke: '#b7eb8f',
        fill: '#f6ffed'
      }
    } else if (IsActive === 3) {
      attrs.body.style = {
        stroke: '#f5f5f5',
        fill: '#f5f5f5'
      }
    } else {
      attrs.body.style = {}
    }
    return {
      id: Sign,
      label: Name,
      data: {
        name: Name,
        processID: ProcessID,
        type: Type,
        inputs: Inputs?.map(input => {
          return {
            ...input,
            SourceNode: nodes.find(item => item.Sign === input.SourceNodeSign)?.Name || ''
          }
        }),
        outputs: Outputs,
        procesDetails: ProcesDetails,
        scriptID: ScriptID,
        subSceneSign: SubSceneSign,
        delay: Delay,
        createdAt: CreatedAt ? dayjs(CreatedAt).format('YYYY-MM-DD HH:mm:ss') : '',
        finishedAt: FinishedAt ? dayjs(FinishedAt).format('YYYY-MM-DD HH:mm:ss') : '',
        urlNotices: UrlNotices,
        userNotices: UserNotices
      },
      attrs,
      shape: Shape,
      size: { width: Size.Width, height: Size.Height },
      position: { x: Position.X, y: Position.Y },
      ports: {
        groups: commonPorts.groups,
        items: Ports?.Items?.map(item => ({ group: item.Group, id: item.ID }))
      }
    }
  })
  return result
}

// 设置边的data
export const handleRouterData = (routers: ProcessRecordRouteProps[]) => {
  if (!Array.isArray(routers)) return []
  const result = routers.map(route => {
    const { Sign, Extra, Name, IsActive, Conditions } = route
    return {
      id: Sign,
      shape: 'edge',
      source: { cell: Extra?.Other.Source.Cell, port: Extra?.Other.Source.Port },
      target: { cell: Extra?.Other.Target.Cell, port: Extra?.Other.Target.Port },
      attrs:
        IsActive !== 2
          ? specialAttrs.edges
          : {
              wrap: {
                strokeWidth: 2
              },
              line: {
                stroke: '#a1d682',
                targetMarker: { height: 8, name: 'block', width: 12 }
              }
            },

      data: {
        name: Name,
        id: Sign,
        conditions: Conditions || []
      },
      labels: [
        {
          attrs: { label: { text: Name, fontSize: 12, fill: 'rgba(0,0,0,0.65)' } }
        }
      ]
    }
  })
  return result
}

// 根据流程中的nodeID获取输入输出参数
export const getProcessParamsInfo = (
  processId: number,
  variables: ProcessRecordVariableProps[]
) => {
  if (!Array.isArray(variables)) return []
  const filteredData = variables.filter(item => item.NodeID === processId)
  return filteredData.reduce(
    (acc, cur) => {
      if (cur.Type === 'input') {
        acc.inputs.push({ key: cur.VariableKey, value: cur.VariableValue, isSecret: cur.IsSecret })
      } else if (cur.Type === 'output') {
        acc.outputs.push({ key: cur.VariableKey, value: cur.VariableValue, isSecret: cur.IsSecret })
      }
      return acc
    },
    { inputs: [], outputs: [] }
  )
}

// 验证节点
export const validateBeforeSave = nodes => {
  let source_key = '' // 数据
  let source_node_sign = '' // 关联数据标识
  let type = '' // 关联类型
  let source_node = null // 关联数据
  let flag = false
  let errorNodeName = ''
  let errorInputKey = ''

  nodes.some((node: ProcessRecordNodeProps) => {
    const inputs = node?.Extra?.Inputs ?? [] // 输入参数
    // 如果不是开始节点并且节点输入参数不为空
    if (node.Type !== 'START' && inputs.length !== 0) {
      flag = inputs.some((i: ProcessRecordNodeInputProps) => {
        source_key = i.SourceKey
        source_node_sign = i.SourceNodeSign
        type = i.Type
        source_node = nodes.find(n => n.Sign === source_node_sign)?.Extra
        if (type === 'node_input') {
          if (!source_node?.Inputs?.some(s => s.Key === source_key) || !source_node) {
            errorNodeName = node.Name
            errorInputKey = i.Key
            return true
          }
          return false
        } else if (type === 'node_output') {
          if (!source_node?.Outputs?.includes(source_key || !source_node)) {
            errorNodeName = node.Name
            errorInputKey = i.Key
            return true
          }
          return false
        }
        return false
      })
    }
    return flag
  })
  return { flag, errorNodeName, errorInputKey }
}

// 场景转json1
export const sceneToJson = cells => {
  if (cells?.length === 0) return { Nodes: [], Routes: [] }
  const Nodes: ProcessRecordNodeProps[] = []
  const Routes: ProcessRecordRouteProps[] = []
  cells.forEach(cur => {
    if (cur.shape === 'edge') {
      Routes.push({
        ProcessID: cur.data?.process_id,
        Name: cur.data?.name,
        Sign: cur.id,
        SrcNodeSign: cur.source.cell,
        DstNodeSign: cur.target.cell,
        Conditions: cur.data?.conditions,
        Extra: {
          Other: {
            ID: cur.id,
            Shape: cur.shape,
            Source: { Cell: cur.source.cell, Port: cur.source.port },
            Target: { Cell: cur.target.cell, Port: cur.target.port }
          }
        }
      })
    } else {
      const Other = {
        Position: { X: cur.position.x, Y: cur.position.y },
        Shape: cur.shape,
        Size: { Width: cur.size.width, Height: cur.size.height },
        Ports: { Items: cur.ports.items.map(item => ({ Group: item.group, ID: item.id })) }
      }
      switch (cur.data.type) {
        case 'START':
        case 'PARALLEL_GATEWAY':
          Nodes.push({
            ProcessID: cur.data?.process_id,
            Name: cur.data.name || cur.attrs.text.text,
            Sign: cur.id,
            Type: cur.data.type,
            Extra: {
              Other
            }
          })
          break
        case 'GATEWAY':
          Nodes.push({
            Name: cur.data.name || cur.attrs.text.text,
            Sign: cur.id,
            Type: 'GATEWAY',
            Extra: {
              Other,
              Inputs: cur.data.inputs,
              ScriptID: cur.data.scriptID,
              Outputs: cur.data.outputs
            }
          })
          break
        case 'AUTOTASK_SUBSCENE':
          Nodes.push({
            Name: cur.data.name || cur.attrs.text.text,
            Sign: cur.id,
            Type: 'AUTOTASK_SUBSCENE',
            Extra: {
              Other,
              Inputs: cur.data.inputs,
              SubSceneSign: cur.data.subSceneSign,
              Outputs: cur.data.outputs
            }
          })
          break
        case 'AUTOTASK_TIMER':
          Nodes.push({
            ProcessID: cur.data?.process_id,
            Name: cur.data.name || cur.attrs.text.text,
            Sign: cur.id,
            Type: 'AUTOTASK_TIMER',
            Extra: {
              Other,
              Delay: cur.data.delay
            }
          })
          break
        case 'END':
        case 'AUTOTASK_DISPLAY':
          Nodes.push({
            Name: cur.data.name || cur.attrs.text.text,
            Sign: cur.id,
            Type: cur.data.type,
            Extra: {
              Other,
              ScriptID: cur.data.scriptID,
              Inputs: cur.data.inputs,
              Outputs: cur.data.outputs
            }
          })
          break
        case 'USERTASK':
          Nodes.push({
            Name: cur.data.name || cur.attrs.text.text,
            Sign: cur.id,
            Type: cur.data.type,
            Extra: {
              Other,
              Inputs: cur.data.inputs,
              Outputs: cur.data.outputs,
              UrlNotices: cur.data.urlNotices,
              UserNotices: cur.data.userNotices
            }
          })
      }
    }
  })
  return {
    Nodes,
    Routes
  }
}

// 复制场景
export const copyScene = async (sceneId: number) => {
  const sceneInfo = await getScene(sceneId)
  const { Name, IsPublic, FormSchema, Sign, ID, Status, Version, Approving, Workflow } = sceneInfo
  const { Nodes, Routes } = Workflow
  const result = {
    formData: {
      name: Name,
      isPublic: IsPublic === 1,
      sign: Sign
    },
    id: ID,
    status: Status,
    formSchema: FormSchema,
    version: Version,
    approving: Approving,
    cells: [...handleNodeData(Nodes), ...handleRouterData(Routes)]
  }
  const promiseArr = []
  result.cells.forEach((item: Cell.Properties) => {
    if (item.data?.type === 'AUTOTASK_DISPLAY') {
      const { scriptID } = item.data
      if (scriptID) {
        promiseArr.push(getScript(scriptID))
      }
    }
  })
  const scriptInfo = await Promise.all(promiseArr)
  if (scriptInfo.some(item => item === false)) {
    return false
  }
  const newCells = result.cells.map((item: Cell.Properties) => {
    if (item?.data?.type === 'AUTOTASK_DISPLAY' && item?.data?.scriptID) {
      const data = scriptInfo?.shift() || {}
      if (data) {
        const { Lang, Content, Type } = data
        item.data.scriptInfo = {
          Lang,
          Content,
          Type
        }
      }
    }
    return item
  })
  return {
    ...result,
    cells: newCells
  }
}

// 粘贴场景：保存脚本
export const saveScriptInfo = async (cells: Cell.Properties[]) => {
  const promiseArr = []
  cells.forEach(item => {
    if (item.data?.type === 'AUTOTASK_DISPLAY') {
      const { scriptInfo } = item.data
      scriptInfo && promiseArr.push(saveScript(scriptInfo))
    }
  })

  const newScriptIds = await Promise.all(promiseArr)
  const newCells = cells.map(item => {
    if (item.data?.type === 'AUTOTASK_DISPLAY') {
      const newScript = newScriptIds.shift()
      if (newScript?.ID) {
        item.data.scriptID = newScript.ID
      }
    }
    return item
  })
  return newCells
}
